export default {
  namespaced: true,

  state: {
    modals: [],
    sidebar: false,
    dropdownGive: false,
    dropdownGet: false
  },

  mutations: {
    add(state, modal) {
      state.modals.push(modal);
    },

    remove(state, index) {
      state.modals.splice(index, 1);
    },
    open(state, payload) {
      state.sidebar = payload;
    },
    openDropdownGive(state) {
      state.dropdownGive = true;
    },
    closeDropdownGive(state) {
      state.dropdownGive = false;
    },
    openDropdownGet(state) {
      state.dropdownGet = true;
    },
    closeDropdownGet(state) {
      state.dropdownGet = false;
    }
  },

  actions: {
    openModal(store, modal) {
      store.commit("add", modal);
    },

    closeModal(store, name) {
      for (let i = store.state.modals.length - 1; i => 0; i--) {
        const item = store.state.modals[i];
        //
        if (item.name === name) {
          store.commit("remove", i);
          return;
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/modals.js